export const routes = ['/feed', '/closet', '/me'];

export const guardedRoute = (srcRoute) =>
  routes.includes(srcRoute) ? srcRoute : routes[0];
